module.exports = __webpack_public_path__ + "img/sobre.d5c9a96c.png";